import React, { Component } from 'react';
import makeRequest from '../../../../requests/base.request'


class FiltroEscola extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            escolas: [],
            escolaSelecionadaIdx: undefined,
            exibirApenasSelecionados: false
        }

        this.onClickToogleExibirSelecionados = this.onClickToogleExibirSelecionados.bind(this);
        this.onChangeEscola = this.onChangeEscola.bind(this);
    }

    componentDidMount() {

        this.getSchools();

    }

    getSchools = async () => {
        try {
            this.setState({ loading: true });

            var schools = await makeRequest.get('escolas')
            schools = schools || [];
            // console.log(schools)

            var escolaSelecionadaIdx = undefined;

            if(this.props.idEscola){
                escolaSelecionadaIdx = schools.findIndex((res) => res.idEntitySchool === this.props.idEscola);
            }
            else if(schools.length === 1) {
                escolaSelecionadaIdx = 0;
                if(this.props.onChange){
                    this.props.onChange(schools[0],escolaSelecionadaIdx)
                }
            }

            await this.setState({ escolas: schools || [], escolaSelecionadaIdx: escolaSelecionadaIdx, loading: false/*, exibirApenasSelecionados: true*/ });

//            this.props.onChange && this.props.onChange(schools[0],0)

        } catch (error) {
            console.error(error)
        }
    }

    onClickToogleExibirSelecionados(){
        this.setState({ exibirApenasSelecionados: !this.state.exibirApenasSelecionados  });
    }

    onChangeEscola(item,index){
        this.setState({ escolaSelecionadaIdx: index, exibirApenasSelecionados: true });

        if(this.props.onChange){
            this.props.onChange(item,index)
        }
    }

    render() {
        return (<div className={this.props.className}>
            <strong>{this.props.filtroRequerido && <span className="edb-padding-small-right edb-text-bold adap-text-red">*</span>}Escola:</strong>
            {this.state.escolas.length > 1 &&
                <button className="edb-btn-link" onClick={this.onClickToogleExibirSelecionados}>
                    {!this.state.exibirApenasSelecionados && <i className="fas fa-chevron-up"></i>}
                    {this.state.exibirApenasSelecionados && <i className="fas fa-chevron-down"></i>}
                </button>
            }
            <br />
            {this.state.loading && <div><small>Carregando...</small></div>}
            {!this.state.loading && this.state.escolas.map((item, index) =>
                (
                    ((this.state.exibirApenasSelecionados && index === this.state.escolaSelecionadaIdx) || !this.state.exibirApenasSelecionados ) &&
                <label key={`filtro-escola-${index}`} className="edb-margin-none-bottom">
                    <input type="radio" name="filtro-escola" value={index} checked={index === this.state.escolaSelecionadaIdx}
                     onChange={() => this.onChangeEscola(item,index)} />
                    &nbsp;
                    <small>{item.txBrandName}</small>
                </label>)
            )}

        </div>);
    }
}

export default FiltroEscola;